import { memo, useMemo, useRef, useState } from "react";
import { MdClose, MdFileCopy, MdInfoOutline } from "react-icons/md";
import { Handle, Position } from "reactflow";

import { useMediaQuery } from "@react-hook/media-query";
import { toNumber } from "lodash";


import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FinancialMetrics, cn, color } from "@/lib/utils";
import { DP22, DP24, getLineColor, getShadowColor } from "@/helpers/helperFunctions";

function capitalize(s: any) {
  return s[0].toUpperCase() + s.slice(1);
}

export default memo(
  ({ id, data, isConnectable }: { data: any; [key: string]: any }) => {

    
    const wrapperRef: any = useRef();
    const isMobile = useMediaQuery("only screen and (max-width: 965px)");
    const [otherList, setOtherList] = useState({}
      
    );
    // const [edges] = useEdgesStateSynced();
    const [otherInputs, setOtherInputs] = useState<any>(data?.other_inputs);
    // const statusList = useSelector((state: any) => state.data.status_list);
    // const statedata = useSelector((state: any) => state.data);
    // const socketData = statedata?.socket as FinancialMetrics | null;
    let globalinputs = {
      "0": "",
      "1": "",
    };

    const toggle = () => {
      setState((prev: any) => ({
        ...prev,
        show: !prev.show,
      }));
    };
    const [state, setState] = useState({
      complete: false,
      show: false,
    });
    const onBlur = () => localStorage.setItem("focus", JSON.stringify(false));
    const onFocus = () => localStorage.setItem("focus", JSON.stringify(true));
    
    // const { DPs, DPPs } = statedata?.isFx
    //   ? { DPs: 4, DPPs: DP24 }
    //   : { DPs: 2, DPPs: DP22 };
    return (
      <>
        <Card
          className="max-w-xs w-screen"
          style={getShadowColor(data?.type, data?.title)}
        >
          {data?.inputs_list?.map((port: any, index: number) => {
            const ids =
              data?.inputs?.length > 0
                ? data.inputs[index].id
                : `${port}-${Math.random()}`;
            const input_name = port;

            if (index === 0) globalinputs["0"] = input_name;
            else globalinputs["1"] = input_name;
            

            return (
              <div className="custom__port" key={index}>
                <Handle
                  type="target"
                  position={Position.Left}
                  className={cn(
                    ` ${data?.title?.split(" ")?.join("")}_${port}`,
                    "port nodrag "
                  )}
                  id={ids}
                  style={{
                    top: 130 + index * 38,
                    ...(isMobile
                      ? { width: 20, height: 20, left: "-10px" }
                      : { width: 13, height: 13 }),
                    backgroundColor:  color.palegreen,
                  }}
                  isConnectable={isConnectable}
                />
                <div
                  className="display__port"
                  style={{
                    top: 122 + index * 38,
                    left: "-7px",
                    backgroundColor: "#c4c4c4",
                  }}
                ></div>
                <div
                  className={`absolute left-3 whitespace-nowrap  max-w-xs w-48 overflow-hidden capitalize`}
                  style={{
                    top: 118 + index * 38,
                  }}
                >
                  {input_name === "LTP" ? "Current Price" : input_name}
                </div>
              </div>
            );
          })}
          <CardHeader>
            <CardTitle>
              <div className="flex items-start justify-between">
                <div
                  className="row"
                  style={{
                    justifyContent: "flex-start",
                    maxWidth: "65%",
                  }}
                >
                  <Tooltip delayDuration={100}>
                    <TooltipTrigger asChild>
                      <div className="text-lg truncate">
                        {data.type === "Data" && data.title === "LTP"
                          ? "Current price"
                          : data?.title?.replace("/", " / ")}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>
                      {data.type === "Data" && data.title === "LTP"
                        ? "Current price"
                        : data?.title?.replace("/", " / ")}
                    </TooltipContent>
                  </Tooltip>
                </div>

              
              </div>
              <CardDescription>
                <div
                  className={`mt-2 text-sm pb-2 ${
                    data.title === "Price Data" ? "yellow__bottom" : ""
                  }`}
                  style={{
                    marginBottom:
                      Math.max(
                        data?.inputs_list?.length,
                        data?.outputs_list?.length
                      ) * 40,
                    borderBottom: ` 1px solid ${getLineColor(
                      data?.type,
                      data?.title
                    )}`,
                  }}
                >
                  <div className="flex gap-3 items-center">
                    <Badge>
                      {data.type === "Pattern" ? "Candle Pattern" : data.type}{" "}
                    </Badge>
                    {/* {(data.title === "Price Data" ||
                      data.title === "Sell" ||
                      data.title === "Current Price" ||
                      data.title === "Buy") && (
                      <span className="block__subheader">
                        {socketData?.closePrice?.toFixed(DPs) ??
                        statedata?.chart?.regularMarketPrice != undefined
                          ? toNumber(
                              statedata?.chart?.regularMarketPrice
                            ).toFixed(DPs)
                          : ""}{" "} */}
                        {/* {socketData?.priceChange ? (
                          <span
                            className={`subHeader ${
                              socketData?.priceChange > 0
                                ? "text-green-foreground"
                                : "text-red-foreground"
                            }`}
                          >
                            {socketData?.priceChange?.toFixed(DPs)} (
                            {socketData?.priceChangePercentage?.toFixed(DPs)}%)
                          </span>
                        ) : (
                          <></>
                        )} */}
                      {/* </span> */}
                    {/* )}{" "} */}
                    {data?.category && <span>{data?.category}</span>}
                  </div>
                </div>
              </CardDescription>
            </CardTitle>
          </CardHeader>
        </Card>

        {data?.outputs_list?.map((port: any, index: number) => {
          const ids =
            data?.outputs?.length > 0
              ? data.outputs[index].id
              : `output-port-${Math.random()}`;
         
          return (
            <div className="custom__port" key={index}>
              <div
                className="label__left"
                style={{
                  position: "absolute",
                  top: 118 + index * 38,
                  right: "12px",
                  textTransform:
                    data?.type === "Indicator" ? "uppercase" : "none",
                }}
              >
                {port}
              </div>
              <Handle
                type="source"
                position={Position.Right}
                className={cn(
                  ` ${data?.title?.split(" ")?.join("")}_${port}`,
                  "port nodrag"
                )}
                id={ids}
                style={{
                  top: 130 + index * 38,
                  ...(isMobile
                    ? { width: 20, height: 20, right: "-9px" }
                    : { width: 13, height: 13 }),
                  backgroundColor:  color.palegreen,
                }}
                isConnectable={isConnectable}
              />

              <div
                className="display__port"
                style={{
                  top: 122 + index * 38,
                  right: "-7px",
                  backgroundColor:"#c4c4c4",
                }}
              ></div>
            </div>
          );
        })}
      </>
    );
  }
);
